export default function multipleCustomSponsors(widgetElName, widgetElOpts) {
  const widgetName = widgetElName;
  const widgetOpts = widgetElOpts;
  const $widget = $(`#${widgetName}`);

  const interval = setInterval(function () {
    if ($('body').hasClass('pageIsLoaded')) {
      if (widgetElName === 'staticSponsors') {
        $(`#${widgetElName}`).wrap('<div class="static-wrapper-sponsors">');
      } else {
        $('#scrollerSponsors').wrap('<div class="wrapper-sponsors">');
      }

      setTimeout(() => {
        if (widgetElName === 'staticSponsors') {
          changeSponsorsStructure();
        } else {
          changeSponsorsStructureDefault();
        }

        const pauseBtn = $(`#${widgetElName} .sponsor-controls-container button`);

        pauseBtn.replaceWith('<span class="sponsor-playpause-btn"></span>');
        $(`#${widgetElName} .sponsor-playpause-btn`).on('click', function () {
          $(`#${widgetElName} .sponsorWidgetContainer `).toggleClass('sponsors-paused');
        });
      }, 1000);

      clearInterval(interval);
    }
  }, 2000);

  function changeSponsorsStructure() {
    $(`#${widgetElName}`).append('<div class="static-scroller-container">');
    $(`#${widgetElName} .sponsorWidgetContainer`).appendTo('.static-scroller-container');
    $(`#${widgetElName} .sponsorCarouselImageContainer`).addClass('static-container');
    $(`#${widgetElName} #sponsorArrowLeft`).appendTo('.static-scroller-container');
    $(`#${widgetElName} #sponsorArrowRight`).appendTo('.static-scroller-container');
  }

  function changeSponsorsStructureDefault() {
    const $majorSponsorTitle = $(`#${widgetElName} #majorSponsorTitleContainer`);
    const $majorSponsorContainer = $(`#${widgetElName} .majorSponsor`);
    const majorSponsorsTitle = $('#majorSponsorTitleContainer .homepageh1').text();

    if ($majorSponsorContainer.length && $majorSponsorTitle.length) {
      $majorSponsorTitle.wrapAll('<div class="major-sponsor-wrapper" id="major-sponsor-wrapper">');
      $majorSponsorContainer.appendTo($('#major-sponsor-wrapper'));
      $('#major-sponsor-wrapper').prependTo($(`#${widgetElName}`));

      $('#majorSponsorTitleContainer .homepageh1').replaceWith(
        `<h2 class="major-sponsor-title">${majorSponsorsTitle}</h2>`,
      );
    }

    const sponsorsTitleContent = $('#sponsorsTitleContainer .homepageh1').text();
    $('#sponsorsTitleContainer .homepageh1').replaceWith(
      `<h2 class="main-sponsors-title">${sponsorsTitleContent}</h2>`,
    );

    $(`#${widgetElName}`).append('<div class="scroller-container">');
    $(`#${widgetElName} .sponsorWidgetContainer `).appendTo('.scroller-container');
    $(`#${widgetElName} .sponsorCarouselImageContainer`).addClass('default-container');
    $(`#${widgetElName} #sponsorArrowLeft`).appendTo('.scroller-container');
    $(`#${widgetElName} #sponsorArrowRight`).appendTo('.scroller-container');
  }

  return saffire.widgets.sponsors($($widget), {
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    timePerSponsor: 4,
    bw: false,
    rotate: true,
  });
}
